import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgLuckyBoxClaimedContentProps } from './msg-lucky-box-claimed-content';
import { MsgLuckyBoxClaimedContent } from './msg-lucky-box-claimed-content';

export interface MsgLuckyBoxClaimedPreviewProps extends MsgLuckyBoxClaimedContentProps {}

export const MsgLuckyBoxClaimedPreview = memo(function MsgLuckyBoxClaimedPreview({
  message,
}: MsgLuckyBoxClaimedPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgLuckyBoxClaimedContent message={message} />
    </LastMessageSystem>
  );
});
